import PropTypes from 'prop-types';
import { Collapse, Tag, Timeline } from 'antd';
import dayjs from 'dayjs';
import styles from './outreach.module.scss';

export const ACTION_LABELS = {
  seed: { label: 'Početno pravilo', color: 'default' },
  generate: { label: 'AI predlog', color: 'purple' },
  create: { label: 'Napravljeno', color: 'green' },
  update: { label: 'Izmenjeno', color: 'blue' },
  status: { label: 'Status', color: 'gold' },
  delete: { label: 'Obrisano', color: 'red' },
  restore: { label: 'Vraćeno', color: 'cyan' },
};

const VIA = {
  dashboard: 'dashboard',
  debug: 'debug konzola',
  system: 'sistem',
};

export const actorText = (a) =>
  a
    ? `${a.name || a.role || 'nepoznat'}${a.via ? ` · ${VIA[a.via] || a.via}` : ''}`
    : '';

const when = (d) => dayjs(d).format('DD.MM.YYYY. HH:mm');

/** The audit trail of one rule (or of all rules), newest first. */
const RuleHistory = ({ events, showRuleKey = false }) => {
  if (!events.length) return <p className={styles.dim}>Nema zapisa.</p>;
  return (
    <Timeline
      className={styles.history}
      items={events.map((e) => {
        const a = ACTION_LABELS[e.action] || {
          label: e.action,
          color: 'default',
        };
        const gen = e.generation;
        return {
          key: e._id,
          color: a.color === 'default' ? 'gray' : a.color,
          children: (
            <div className={styles.event}>
              <div className={styles.eventHead}>
                <Tag color={a.color}>{a.label}</Tag>
                {e.version ? (
                  <span className={styles.dim}>v{e.version}</span>
                ) : null}
                {showRuleKey && e.ruleKey ? (
                  <span className={styles.dim}>{e.ruleKey}</span>
                ) : null}
                <span className={styles.dim}>{when(e.createdAt)}</span>
                <span className={styles.actor}>{actorText(e.actor)}</span>
              </div>
              {e.prompt && <div className={styles.prompt}>„{e.prompt}“</div>}
              {gen && (
                <div className={styles.dim}>
                  {gen.interpretation}
                  {gen.acceptedBy ? (
                    <Tag color="green" className={styles.inlineTag}>
                      prihvaćeno
                    </Tag>
                  ) : (
                    <Tag className={styles.inlineTag}>nije sačuvano</Tag>
                  )}
                  {gen.errors?.length > 0 && (
                    <Tag color="red">greške: {gen.errors.length}</Tag>
                  )}
                </div>
              )}
              {e.changes?.length > 0 && (
                <ul className={styles.tightList}>
                  {e.changes.map((c, i) => (
                    <li key={`${e._id}-${i}`}>{c}</li>
                  ))}
                </ul>
              )}
              {e.note && <div className={styles.dim}>Napomena: {e.note}</div>}
              {gen && (
                <Collapse
                  size="small"
                  ghost
                  items={[
                    {
                      key: 'raw',
                      label: 'Šta je AI dobio i vratio',
                      children: (
                        <div className={styles.raw}>
                          <div className={styles.dim}>
                            {gen.model} · {gen.usage?.inputTokens ?? 0} ulaz /{' '}
                            {gen.usage?.outputTokens ?? 0} izlaz tokena ·{' '}
                            {gen.latencyMs} ms
                          </div>
                          <strong>Poslato:</strong>
                          <pre>{gen.input?.message}</pre>
                          <strong>Vraćeno:</strong>
                          <pre>{gen.output}</pre>
                        </div>
                      ),
                    },
                  ]}
                />
              )}
            </div>
          ),
        };
      })}
    />
  );
};

RuleHistory.propTypes = {
  events: PropTypes.array.isRequired,
  showRuleKey: PropTypes.bool,
};

export default RuleHistory;
